import React from 'react'
import styled from 'styled-components'
import { Portal } from 'reakit'
import { Loader } from '@zuto/icons'

const Background = styled.div`
  background-color: rgb(255 255 255 / 50%);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  z-index: 999;

  svg {
    margin: auto;
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`

const Loading = () : JSX.Element => (
  <Portal>
    <Background id="loading">
      <Loader />
    </Background>
  </Portal>
)

export default Loading
